/** Primary display label for a user / participant (matches server messaging displayName). */
export function userDisplayLabel(u) {
  if (!u) return 'User';
  return u.labName || u.clinicName || u.companyName || u.name || 'User';
}
